import * as React from 'react'
import { Box } from "@mui/material"
import { formatPriceSymbol } from "@ui-seeker/utils"


export default function priceColumn(key, label) {
	return {
		name: key, label: label,
		options: {
			headerAlign: 'center',
			setCellProps: () => ({ sx: { minWidth: '150px' }}),
			customBodyRowRenderLite: (value, { currency }) => <Box sx={{ textAlign: 'center' }}>
				{formatPriceSymbol(value, currency)}
			</Box>
		}
	}
}